"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Get paragraph block height
 *
 * @param  {Object}  paragraph block
 * @return {number} paragraph block height
 */

var height = function height(paragraph) {
  return paragraph.reduce(function (acc, block) {
    return acc + block.box.height;
  }, 0);
};

var _default = height;
exports["default"] = _default;